const Boglanish = ()=>{
    return(
        <>
            Boglanish
        </>
    )
}
export default Boglanish;